import * as types from './types';
import {
    GET_MARKET_GROUPS,
    SET_ALL_MARKETS_SELECTED_EVENT,
    SET_FILTERED_MARKET_GROUPS,
    SET_MARKETS_COLLAPSED,
    SET_SELECTED_MARKET_GROUP,
} from './types';
import MarketGroupService from '../../services/MarketGroupService';

export const changeSelectedMarket = (marketId, changedIndex) => dispatch => {
    dispatch({
        type: types.CHANGE_SELECTED_MARKET,
        payload: { marketId, changedIndex },
    });
};

export const clearAllMarkets = () => async dispatch => {
    dispatch({
        type: types.CLEAR_ALL_MARKETS,
    });
};

export const setAllMarketsSelectedEvent = event => ({
    type: SET_ALL_MARKETS_SELECTED_EVENT,
    payload: event,
});

export const getMarketGroups = params => async dispatch => {
    const response = await MarketGroupService.getMarketGroups(params);

    if (response && response.info.success) {
        dispatch({
            type: GET_MARKET_GROUPS,
            payload: response.items,
        });
    }
};

export const setSelectedMarketGroup = groupId => ({
    type: SET_SELECTED_MARKET_GROUP,
    payload: groupId,
});

export const setFilteredMarketGroups = ({ sportRefId }) => (dispatch, getStore) => {
    const store = getStore();
    const { marketGroups } = store.allMarkets;

    const filteredMarketGroups = marketGroups.filter(group => group.sportId === sportRefId);

    dispatch({
        type: SET_FILTERED_MARKET_GROUPS,
        payload: filteredMarketGroups,
    });
};

export const setMarketsCollapsed = state => ({
    type: SET_MARKETS_COLLAPSED,
    payload: state,
});
